import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Order, Transaction } from '../_models/index';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class OrdersService {

  order: Observable<Order | null>;
  public ordersCollection: AngularFirestoreCollection<Order>;
  public orders: Observable<any>;

  constructor(
    private afs: AngularFirestore,
    private auth: AuthenticationService
  ) {}

  async addTransactionAndOrders(transactionData: any, ordersData: any) {
    const transactionId = transactionData.transactionId;    
    transactionData.id = transactionId;
    await this.afs.collection('transactions').doc(transactionId).set(transactionData);       
    let transactionDoc = this.afs.collection('transactions').doc(transactionId);  
    let today = new Date();      
    let orderId; 
    try {
      ordersData.forEach((order: Order) => {
        orderId = this.afs.createId(); // Randomly generated ID to use as document key
        order.id = orderId;
        order.relatedTransaction = transactionDoc.ref;
        order.transactionId = transactionId;
        order.createdAt = today;
        order.numOfOrdersInTransaction = ordersData.length.toString();
        order.status = transactionData.dropoff ? 'Awaiting Drop Off' : 'Order Placed';
        this.afs.collection('orders').doc(orderId).set(order);
      });
      return true;
    } catch (err) {
      return {
        error: err
      };
    }  
  }

  /* addTransactionAndOrders(transactionData: any, ordersData: any, cb: Function) {
    const transactionId = transactionData.transactionId;    
    transactionData.id = transactionId;
    this.afs.collection('transactions').doc(transactionId).set(transactionData).then(() => {        
      let transactionDoc = this.afs.collection('transactions').doc(transactionId);  
      let today = new Date();      
      let orderId;      
      ordersData.forEach((order: Order) => {
        orderId = this.afs.createId(); // Randomly generated ID to use as document key
        order.id = orderId;
        order.relatedTransaction = transactionDoc.ref;
        order.transactionId = transactionId;
        order.createdAt = today;
        order.numOfOrdersInTransaction = ordersData.length.toString();
        order.status = 'Order Placed';
        this.afs.collection('orders').doc(orderId).set(order).then((orderRef) => {
          console.log('Order added');
        });
      });
      cb(true);
    }).catch(function(error) {
      console.error('Error updating document: ', error);
    });
  } */

  getOrders(userRef) {
    return this.ordersCollection = this.afs.collection('orders', ref => 
      ref.where('user', '==', userRef).orderBy('createdAt', 'desc')
    );
  }


}
